import { Session } from '@/common/types/session';
import { FSProperties } from '@/fullstory/utils/fullstory-event';

export function fullstoryCheckoutPropsFromSession(session: Session): FSProperties {
  return Object.fromEntries(
    Object.entries({
      age_range:
        session.cart?.age_range_id ??
        (session.cart?.is_over_25 ? 'AT_OR_OVER_25' : 'LESS_THAN_25'),
      credit_range: session.cart?.credit_score_id?.toUpperCase(),
      ...session.fullstory_params?.utm,
      ...session.fullstory_params?.checkout,
    }).filter(([, value]) => value !== undefined && value !== null)
  ) as FSProperties;
}
